import { Injectable } from '@angular/core';
import moment from 'moment-timezone';

export type UTCOffset = number | 'local' | 'utc' | 'secca';

@Injectable({
  providedIn: 'root'
})
export class MomentHelperService {
  public static resolveUtcOffset(utcOffSet: UTCOffset): UTCOffset {
    if (!utcOffSet || utcOffSet === 'utc') {
      return 0;
    }
    if (utcOffSet === 'local') {
      return moment().utcOffset();
    }
    if (utcOffSet === 'secca') {
      return moment()
        .tz('Europe/Copenhagen')
        .utcOffset();
    }
    return utcOffSet;
  }

  public static getDaysRangeBothIncl(dt1: moment.Moment, dt2: moment.Moment): number | null {
    if (dt1 && dt2) {
      return dt2.diff(dt1, 'days') + 1;
    } else {
      return null;
    }
  }

  public static getSeccaTime(): moment.Moment {
    return moment().tz('Europe/Copenhagen');
  }
}
